import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileContactCTA from "@/components/MobileContactCTA";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Team from "@/pages/about/Team";
import Timeline from "@/pages/about/Timeline";
import Gallery from "@/pages/about/Gallery";
import Price from "@/pages/Price";
import Products from "@/pages/Products";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { SettingsProvider } from "@/lib/settings";
import { useTrackPageViews } from "@/lib/analytics";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const AnalyticsTracker = () => {
  useTrackPageViews();
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-[#f7f7f5] text-[#1c1c1e]">
      <SettingsProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AnalyticsTracker />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/about/team" element={<Team />} />
              <Route path="/about/timeline" element={<Timeline />} />
              <Route path="/about/gallery" element={<Gallery />} />
              {/* Legacy routes kept as redirects so external links keep working */}
              <Route path="/about/people" element={<Navigate to="/about/team" replace />} />
              <Route path="/about/founder" element={<Navigate to="/about/team" replace />} />
              <Route path="/about/mission" element={<Navigate to="/about/team" replace />} />
              <Route path="/about/vision" element={<Navigate to="/about/team" replace />} />
              <Route path="/about/values" element={<Navigate to="/about/team" replace />} />
              <Route path="/about/purpose" element={<Navigate to="/about/team" replace />} />
              <Route path="/price" element={<Price />} />
              <Route path="/products" element={<Products />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
            </Routes>
          </main>
          <MobileContactCTA />
          <Footer />
        </BrowserRouter>
      </SettingsProvider>
    </div>
  );
}

export default App;
